import React, { useState } from 'react';
import Box from '@amzn/awsui-components-react/polaris/box';
import Button from '@amzn/awsui-components-react/polaris/button';
import Header from '@amzn/awsui-components-react/polaris/header';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import Table from '@amzn/awsui-components-react/polaris/table';
import TextFilter from '@amzn/awsui-components-react/polaris/text-filter';
import Pagination from '@amzn/awsui-components-react/polaris/pagination';
import { useCollection } from '@amzn/awsui-collection-hooks';
import { TableEmptyState, TableNoMatchState } from '../../../commons/common-components';
import { COLUMN_DEFINITIONS } from '../../../homepagecolumns';
import { useColumnWidths } from '../../../commons/use-column-widths';
import { CaptionCornerModel } from '../../../services/api';
import { useFileList } from '../../../hooks/useFileList';
import { TABLE_CONFIG, COLUMN_DISPLAY } from '../../../constants';
import TranscriptionNotifications from '../../../components/TranscriptionNotifications';

export const ListOfVideos: React.FC = () => {
  const [columnDefinitions] = useColumnWidths(TABLE_CONFIG.WIDTHS_STORAGE_KEY, COLUMN_DEFINITIONS);
  const [selectedItems, setSelectedItems] = useState<CaptionCornerModel[]>([]);
  const { files, totalFiles, loading, error, refreshFiles } = useFileList();

  const { items, actions, filterProps, paginationProps } = useCollection(
    files,
    {
      filtering: {
        empty: <TableEmptyState resourceName="Files" />,
        noMatch: <TableNoMatchState onClearFilter={() => actions.setFiltering('')} />,
      },
      pagination: { pageSize: TABLE_CONFIG.PAGE_SIZE },
      sorting: {
        defaultState: {
          sortingColumn: columnDefinitions[0],
          isDescending: true
        }
      },
    }
  );

  React.useEffect(() => {
    refreshFiles();
  }, [refreshFiles]);

  if (error) {
    return (
      <Box color="text-status-error" textAlign="center" padding="l">
        {error}
      </Box>
    );
  }

  return (
    <SpaceBetween size="m">
      
      <Table
        columnDefinitions={columnDefinitions}
        columnDisplay={COLUMN_DISPLAY}
        items={items}
        loading={loading}
        loadingText="Loading files"
        stickyHeader={true}
        stripedRows={true}
        wrapLines
        empty={
          <Box
            margin={{ vertical: "xs" }}
            textAlign="center"
            color="inherit"
          >
            <SpaceBetween size="m">
              <b>You haven't processed any files yet</b>
              <Button href="/uploadfiles" variant="primary">
                Upload file(s)
              </Button>
            </SpaceBetween>
          </Box>
        }
        filter={
          <TextFilter
            {...filterProps}
            filteringPlaceholder="Find files"
            filteringAriaLabel="Filter files"
          />
        }

        header={
          <div>
              <Header
          counter={
            selectedItems.length
              ? `(${selectedItems.length}/${totalFiles})`
              : `(${totalFiles})`
          }
        >
          Files that you've previously processed
        </Header>
             <TranscriptionNotifications />
          </div>
        
        
      }
        pagination={<Pagination {...paginationProps} />}
      />
    </SpaceBetween>
  );
};




